import { Component, OnInit } from '@angular/core';
import { SettingsGeneral } from '../../../_models/admin/settings/settings.general';
import { ActivatedRoute } from '@angular/router';
import { AdminSettingsService } from '../../../_services/admin/admin-settings.service';

@Component({
  selector: 'app-admin-settings-general',
  templateUrl: './admin-settings-general.component.html',
  styleUrls: ['./admin-settings-general.component.scss']
})
export class AdminSettingsGeneralComponent implements OnInit {
  settings: SettingsGeneral;

  constructor(
    public adminSettingsService: AdminSettingsService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.route.data
      .subscribe((data: any) => {
        this.settings = data.settings;
      });
  }
}
